import React, { ReactNode, useState } from 'react';
import { AddonCategoryFormType, NewAddonContext } from './context';

const NewAddonProvider = ({ children }: { children: ReactNode }) => {
  const [newAddonData, setNewAddonData] = useState<AddonCategoryFormType>({
    meal_addon_category_id: [],
    brand_id: [],
    parent_meal_id: [],
    meal_addon_category_options: [],
    addons: [{ base_meal_id: '', default: false, name: '', amount: '' }]
  });
  const [isValid, setIsValid] = useState(false);

  return (
    <NewAddonContext.Provider
      value={{
        newAddonData,
        setNewAddonData,
        isValid,
        setIsValid
      }}>
      {children}
    </NewAddonContext.Provider>
  );
};

export default NewAddonProvider;
